import { getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Gets the current frameworks.
 */
export const getDownloadFrameworks = factoryAuthService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/conveniosmarco/vigente`)
)
